import { render, staticRenderFns } from "./LicensesTab.vue?vue&type=template&id=76bd6685&"
import script from "./LicensesTab.vue?vue&type=script&lang=ts&"
export * from "./LicensesTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports